export enum PERMISSION_STATUS {
  DENIED = 1,
  ALLOWED = 2,
}

export const PERMISSION_STATUS_OPTIONS_LIST = [
  { label: 'Запрещено', value: PERMISSION_STATUS.DENIED },
  { label: 'Разрешено', value: PERMISSION_STATUS.ALLOWED },
];

export enum PERMISSION_ACTION {
  VIEW = 'VIEW',
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  LOGIN = 'LOGIN',
}

export enum PERMISSION_SUBJECT {
  ALL = 'all',
  DASHBOARD = 'DASHBOARD',
  COMPLAINTS = 'COMPLAINTS',
  USERS = 'USERS',
  PURCHASES = 'PURCHASES',
  WITHDRAWALS = 'WITHDRAWALS',
  ADMIN = 'ADMIN',
  SYSTEM = 'SYSTEM',
  AS_USER = 'AS_USER',
  MODERATION_CLIENTS = 'MODERATION_CLIENTS',
  MODERATION_SPECIALISTS = 'MODERATION_SPECIALISTS',
}

export type Permission = {
  action: PERMISSION_ACTION;
  subject: PERMISSION_SUBJECT;
};

export type Permissions = Permission[];

export type ModulePermission = {
  id: string;
  name: string;
  moduleName: string;
  value: PERMISSION_STATUS;
  isEditable: boolean;
};

export type ModulePermissions = ModulePermission[];
